import * as React from "react";
import Status from "widget/detailHead/status";
import Tag from "widget/detailHead/tag";
import OrderInfo from "widget/detailFrom/orderInfo";
import HotelInfo from "widget/detailFrom/hotelInfo";
import ContactInfo from "widget/detailFrom/contactInfo";
import TravelInfo from "widget/detailFrom/travelInfo";
import Paymentlist from "widget/detailFrom/paymentlist";
import Remark from "widget/detailFrom/remark";
import Aftersale from "widget/detailFrom/aftersale";
import Refund from "widget/detailFrom/refund";
import Emailist from "widget/detailFrom/emailist";
import Loglist from "widget/detailFrom/loglist";
import Userlist from "widget/detailFrom/userlist";
import Costlist from "widget/detailFrom/costlist";
import Wechatlist from "widget/detailFrom/wechatlist";
import Dispatchlist from "widget/detailFrom/dispatchlist";
import SmallTools from "widget/smallTools";
import Button from "widget/detailHead/button";
import { Tooltip,Tabs,Button as Buttonantd,Input,InputNumber,message,Icon} from 'antd';
import { EUrl } from "utils/enum/url";
import { CopyToClipboard } from "react-copy-to-clipboard";

const TabPane = Tabs.TabPane;
const { TextArea } = Input;

// 小工具栏

// 生成唯一的可识别id
import cuid from "cuid";

import "styles/orderDetail.scss";
//import { object } from "prop-types";

class OrderDetails extends React.Component<any, any> {
  // 表单唯一标识
  statusCuid = cuid();

  constructor(props: any) {
    super(props);
    this.state = {
        id : this.props.match.params.id,
        wsize:0,
        visible:false,
        activeKey:0,
    };
  }

  initAdditionals = () => {
    if(!this.props.additionals){
       return false;
    }
    const listItems = this.props.additionals.map((item,key) => {
          let adultnumTxt = item.adult_num ? (<span>  成人：<InputNumber max={item.max_adult_num} min={0} defaultValue={item.adult_num}  /> </span>): '';
          let numTxt = item.num ? (<span>  数量：<InputNumber max={item.max_num} min={0} defaultValue={item.num}  /></span>) : '';
          let childrennumTxt = item.children_num ?(<span>  儿童： <InputNumber max={item.max_children_num} min={0} defaultValue={item.children_num}  /></span>) : '';
          return(
               <div key={key} className="add-l"><strong>附加项目({key+1})：</strong>{item['sku_name']} {numTxt} {adultnumTxt} {childrennumTxt}</div>
          )
    })
    return (
       <React.Fragment>
                       <div className="additionals">
                          {listItems}
                      </div>        
       </React.Fragment>
    )  
  }

  // 初始化表单
  initFrom = () => {
    let thList : any = [];
    if(this.props.orderInfo){
      thList.push(<th key='chuxin'>出行信息</th>);
    }
    if(this.props.hotelInfo){
      thList.push(<th key='jiudian'>酒店</th>);
    }
    if(this.props.contactInfo){
      thList.push(<th key='lianxi'>联系人</th>);
    }  
    if(this.props.travelInfo || this.props.driverInfo || this.props.passengerInfo){
      thList.push(<th key='cxr'>出行人</th>);
    }      
    return (
      <table>
        <tbody>
          <tr>
            {thList}
          </tr>
          <tr>
            <OrderInfo  OrderInfo={this.props.orderInfo} ErrorInfo={this.props.errorInfo} data={this.props.data} readonly={this.props.readonly} updateDataValue={this.props.updateDataValue} getQNConfig={this.props.getQNConfig}/>
            <HotelInfo hotelInfo={this.props.hotelInfo} data={this.props.data} readonly={this.props.readonly} updateDataValue={this.props.updateDataValue}/>
            <ContactInfo ErrorInfo={this.props.errorInfo} orderDetails={this.props.orderDetails} contactInfo={this.props.contactInfo} data={this.props.data} readonly={this.props.readonly} updateDataValue={this.props.updateDataValue} getTraveler={this.props.getTraveler}/>
            <TravelInfo orderDetails={this.props.orderDetails} ErrorInfo={this.props.errorInfo} orderInfo={this.props.orderInfo} travelInfo={this.props.travelInfo} readonly={this.props.readonly} driverInfo={this.props.driverInfo} passengerInfo={this.props.passengerInfo} data={this.props.data} getTraveler={this.props.getTraveler} updateDataValue={this.props.updateDataValue} id={this.props.id} orderStatus={this.props.status}/>
          </tr>
          </tbody>   
      </table>
    );
  };

  batchSign = () => {
    const param: any = {
      ids: this.state.id
    };    
    this.props.batchSign({
      ...param,
      callback: () => {
         this.cancel();
      }
     });     
  };

  submit = () => {
    const param = this.props.data;
    this.props.submit({
      ...param,
      callback: (data) => {
        console.log(data)
        
        if(typeof data.data == 'object'){
          this.props.updateErroInfo(data.data); 
          setTimeout(() => {
            this.props.updateErroInfo({888:'888'});
          }, 8000);      
        }
        if(data.code != 1001){
          const params: any = {
            id: this.props.id
          }; 
          this.props.getOrderDetails({
             ...params,
             callback: () => {
             }
           });
        }
      }
     });    
      //console.log(this.props.data);
  }

  cancel = () => {
    const param: any = {
      id: this.state.id
    }; 
    this.props.getOrderDetails({
      ...param,
      callback: () => {
        console.log(this.props);
      }
     });
  }

  isMessage = (buyersMessage) => {
    if(buyersMessage != ""){
      return(
        <p><label>买家留言：</label>{buyersMessage}</p>
      )
    }else{
      return(
        <p><label>买家留言：</label>无</p>
      )
    }
    console.log(this.props.data);
  }

  associatedOrder = (associated) => {
    
    const listItems = associated.map((item,key) => {
      console.log(item);
      let url = "/app/orderDetails/"+item.id;
      return(
         <a href={url} key={key}>{item.number}   &nbsp;&nbsp;&nbsp;&nbsp;</a>
       )        
    })
    return (
      <React.Fragment>
          <span>
              {listItems}
          </span>        
      </React.Fragment>
   ) 
  }

  onChange = (value) =>{
    if(value instanceof Object){
       console.log(value.target.value)
       this.props.updateDataValue({id:'remark',value:value.target.value});
    }  
  }

  onOk= () =>{
    message.success("复制成功");
  }

  onChangeTab = (value) =>{
     console.log(this.props.tabStatus);
     this.props.updateTabStatus(value);
  }

  initComponents = () => {
   // return this.props.orderDetails.id;
   const url = EUrl.wangwang.replace("@var@", this.props.orderDetails.taoAccount);
   return (
    <React.Fragment>
      <div>
         <div className='head'>
             <div className='clear'>
             <Status orderStatus={this.props.orderStatus}/>
             <Tag Tag={this.props.tags} OrderNo={this.props.orderDetails.id}/>
             
             </div>
             <div className='clear'>
                 <Button IsMail={this.props.isMail} /> 
             </div>
         </div>
         <div className='content' >
              <div className="wangwang"> 
                    {this.props.orderDetails.taoAccount? <Tooltip placement="top" title="复制账号"><CopyToClipboard text={this.props.orderDetails.taoAccount}><a onClick={this.onOk}><Icon type="copy" /></a></CopyToClipboard> 淘宝账号 : {this.props.orderDetails.taoAccount} <a href={url} target="_blank"><i className="action-user action-wangwang" style={{ cursor: "pointer", color: "#2b9fbd" }}/></a></Tooltip>:''}
                    {this.props.orderDetails.mallAccount?<span>   <CopyToClipboard text={this.props.orderDetails.mallAccount}><a onClick={this.onOk}><Icon type="copy" /></a></CopyToClipboard> 商城账号 : {this.props.orderDetails.mallAccount}</span> :''}
               </div>
              <div className="customer">

                {this.props.orderDetails.head ? <div className="kefu">客服：{this.props.orderDetails.head}</div> :<Buttonantd onClick={this.batchSign} style={{backgroundColor: "#2b9fbd" }} type="primary">签名</Buttonantd>}
              </div>
              <Tabs  type="card" onChange={this.onChangeTab}>
                  <TabPane tab="订单详情" key="tab1" className="order-from">
                          <div className='sub'>
                         <div className='submit'>
                         <Buttonantd className='gray' type="primary" onClick={this.cancel} size='large'>取消</Buttonantd>
                         <Buttonantd style={{backgroundColor: "#2b9fbd" }} type="primary" size='large' onClick={this.submit}>确认提交</Buttonantd>
                        </div>
                      </div>
                       <div className='all-order'>
                          <div className='order-left'>
                            <dl className='pull-left'>
                             <dd className='clear'>
                                <strong>订单编号：</strong>{this.props.orderDetails.orderNumber}
                             </dd>
                             <dd className='clear'>
                             <strong>SKU编号：</strong>{this.props.orderDetails.skuNumber} 
                             </dd>
                             <dd className='clear'>
                             <strong>下单日期：</strong> {this.props.orderDetails.submitDate}
                             </dd>
                             <dd className='clear'>
                             <strong>审核日期：</strong>  {this.props.orderDetails.verifyTime}
                             </dd>
                             <dd className='clear'>
                             <strong>SKU名称：</strong> <Tooltip placement="top" title={this.props.orderDetails.skuName}> <a target="_blank" href={this.props.orderDetails.goodsUrl}>{this.props.orderDetails.skuName}</a> </Tooltip>
                             </dd>
                             <dd className='clear'>
                             <strong>关联订单：</strong> {this.props.orderDetails.associatedOrder ? this.associatedOrder(this.props.orderDetails.associatedOrder):''} 
                             </dd>
                           </dl>
                           <dl className='pull-right'>
                             <dd className='clear'>
                             <strong>订单来源：</strong> {this.props.orderDetails.fromSource} 
                             </dd>
                             <dd className='clear'>
                             <strong>商品分类：</strong>{this.props.orderDetails.category}
                             </dd>
                             <dd className='clear'>
                             <strong>行程公司：</strong>{this.props.orderDetails.travelCompany}
                             </dd>
                             <dd className='clear'>
                             <strong>&nbsp;&nbsp;&nbsp;供应商：</strong>{this.props.orderDetails.supplierCode}
                             </dd>
                             <dd className='clear'>
                             <strong>天猫短码：</strong>{this.props.orderDetails.tianmaoCode}
                             </dd>
                             <dd className='clear'>
                             <strong>付款信息：</strong><Paymentlist  />
                             </dd>
                           </dl>

                          </div>
                          <div className='order-right'>
                             <div className="buyers-Message">{this.isMessage(this.props.orderDetails.buyersMessage)}</div> 
                             <p className='p-re'><label>备注：</label><span className='text-pos'><TextArea  onChange={this.onChange}  value={this.props.data['remark']} rows={4} cols={30} />(备注信息会显示在确认单上)</span>

                             </p>
                          </div>
                      </div>
                      <SmallTools
                        content={this.initAdditionals()}
                        isOpenEnlarge={false}
                        isOpenFieldDrawer={false}
                      />
                      <div className='from-order'>
                      <SmallTools
                        content={this.initFrom()}
                        isOpenEnlarge={false}
                        isOpenFieldDrawer={false}
                      />
                      </div>   
                  </TabPane>
                  <TabPane tab="备忘录" key="tab2">
                  <Remark />
                  </TabPane>
                  <TabPane tab="售后" key="tab3">
                  <Aftersale/>
                  </TabPane>
                  <TabPane tab="退款记录" key="tab4">
                  <Refund/>
                  </TabPane>
                  <TabPane tab="邮件记录" key="tab5">
                  <Emailist/>
                  </TabPane>
                  <TabPane tab="订单日志" key="tab6">
                  <Loglist />
                  </TabPane>
                  <TabPane tab="用户订单" key="tab7">
                  <Userlist/>
                  </TabPane>
                  <TabPane tab="订单成本" key="tab8">
                  <Costlist/>
                  </TabPane>
                  <TabPane tab="微信行中消息记录" key="tab9">
                  <Wechatlist/>
                  </TabPane>
                  <TabPane tab="车辆信息" key="tab10">
                  <Dispatchlist/>
                  </TabPane>
              </Tabs> 
         </div>

      </div>

    </React.Fragment>
   )
  }
  
  

  // 组件完成加载后触发的事件
  componentDidMount() {
    const param: any = {
      id: this.state.id
    }; 
    this.props.getOrderDetails({
      ...param,
      callback: () => {
        console.log(this.props);
      }
     });
     //const orderListDom = document.querySelector(".ant-tabs-content");
   }

  render() {
    return (
      <div className="formDemo1">
       {this.initComponents()}
      </div>
    );
  }
}

export default OrderDetails;
